import React, { useEffect, useState } from 'react';
import { BodyText } from "@hm-group/fabric-components/components/Typography";
import { IconButton } from "@hm-group/fabric-components/components/Buttons";
import { Modal } from "@hm-group/fabric-components/components/Panels/Modal";
import { PrimaryButton } from "@hm-group/fabric-components/components/Buttons";
import { FavouriteActiveIcon } from "@hm-group/fabric-icons/icons/FavouriteActiveIcon";
import { FavouriteInactiveFilledIcon } from "@hm-group/fabric-icons/icons/FavouriteInactiveFilledIcon";
import consoleEvents from '@hm-group/frontend-utils/logging/consoleEvents';
import cn from 'classnames';
const FavouritesButton = ({ initialFavouriteStatus = false, className, articleCode, onFavouritesClick, favouritesLabels, variant = 'hm', removeActions, addActions, activeClassName = '', }) => {
    const [isFavourite, setIsFavourite] = useState(initialFavouriteStatus);
    const [modal, setModal] = useState({ show: false, text: '', title: '' });
    const { favouriteActive, favouriteInactive, popupConfirm, close, favouriteslimitText, favouriteslimitTitle, favouriteErrorText, favouriteErrorTitle, favouriteRemoveError, } = favouritesLabels;
    const { getRemoveFromFavouritesError, performRemoveFromFavourites } = removeActions;
    const { getAddToFavouritesError, performAddToFavourites } = addActions;
    const iconSize = variant === 'northstar-large' || variant === 'northstar-small' ? 'small' : 'medium';
    const handleError = (favouriteState, errorType) => {
        consoleEvents.error(`Error while ${errorType} a Favourite: ${articleCode}`);
        setIsFavourite(!favouriteState);
    };
    const toggleModal = () => {
        setModal(Object.assign(Object.assign({}, modal), { show: false }));
    };
    // Update state after props-change
    useEffect(() => {
        setIsFavourite(initialFavouriteStatus);
    }, [initialFavouriteStatus, articleCode]);
    useEffect(() => {
        if (getAddToFavouritesError) {
            if ((getAddToFavouritesError === null || getAddToFavouritesError === void 0 ? void 0 : getAddToFavouritesError.code) === '1004') {
                setModal({
                    show: true,
                    text: favouriteslimitText,
                    title: favouriteslimitTitle,
                });
            }
            else {
                setModal({
                    show: true,
                    text: favouriteErrorText,
                    title: favouriteErrorTitle,
                });
            }
            handleError(isFavourite, 'add');
        }
    }, [getAddToFavouritesError]);
    useEffect(() => {
        if (getRemoveFromFavouritesError) {
            setModal({ show: true, text: favouriteRemoveError, title: favouriteErrorTitle });
            handleError(isFavourite, 'remove');
        }
    }, [getRemoveFromFavouritesError]);
    const useOnClickEvent = () => {
        if (isFavourite) {
            performRemoveFromFavourites();
        }
        else {
            performAddToFavourites();
        }
        if (onFavouritesClick) {
            onFavouritesClick(isFavourite, articleCode);
        }
        setIsFavourite(!isFavourite);
    };
    if (!favouriteInactive || !favouriteActive) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { type: "button", className: cn(className, isFavourite && activeClassName), onClick: useOnClickEvent, iconElement: isFavourite ? (React.createElement(FavouriteActiveIcon, { size: iconSize })) : (React.createElement(FavouriteInactiveFilledIcon, { size: iconSize })) }, isFavourite ? favouriteActive : favouriteInactive),
        React.createElement(Modal, { closeLabel: close, heading: modal.title, isOpen: modal.show, content: React.createElement(BodyText, null, modal.text), onClose: toggleModal, actions: React.createElement(PrimaryButton, { onClick: toggleModal }, popupConfirm) })));
};
export default FavouritesButton;
//# sourceMappingURL=FavouritesButton.js.map